"use strict";exports.PollUpdateEvent=class{constructor(s,t){this.pollId=0,this.messageId=0,this.pollId=t.poll.id,this.messageId=t.poll.message_id,this._iid=s,this._payload=t}};
